import { render, staticRenderFns } from "./DonateBox.vue?vue&type=template&id=631ef52a&scoped=true"
import script from "./DonateBox.vue?vue&type=script&lang=ts"
export * from "./DonateBox.vue?vue&type=script&lang=ts"
import style0 from "./DonateBox.vue?vue&type=style&index=0&id=631ef52a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631ef52a",
  null
  
)

export default component.exports